(() => {
  const selector = 'video[data-reytel-lazy-video]';
  const supportsObserver = 'IntersectionObserver' in window;

  function hydrate(video) {
    if (!video || video.dataset.reytelVideoLoaded === 'true') return;

    let changed = false;
    if (video.dataset.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      changed = true;
    }

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      changed = true;
    });

    video.dataset.reytelVideoLoaded = 'true';
    if (changed) video.load();
    video.dispatchEvent(new CustomEvent('reytel:video-loaded'));
  }

  function playAutoplayVideo(video) {
    if (!video.autoplay || document.hidden) return;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  const loadObserver = supportsObserver
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrate(entry.target);
          loadObserver.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px', threshold: 0 })
    : null;

  const playbackObserver = supportsObserver
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            hydrate(video);
            playAutoplayVideo(video);
          } else if (video.autoplay && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: 0.05 })
    : null;

  function register(video) {
    if (video.dataset.reytelLazyRegistered === 'true') return;
    video.dataset.reytelLazyRegistered = 'true';
    video.addEventListener('pointerdown', () => hydrate(video), { passive: true });
    video.addEventListener('focusin', () => hydrate(video));

    if (supportsObserver) {
      loadObserver.observe(video);
      playbackObserver.observe(video);
    } else {
      hydrate(video);
      playAutoplayVideo(video);
    }
  }

  function scan(root = document) {
    if (root.matches && root.matches(selector)) register(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(register);
  }

  window.reytelLoadVideo = hydrate;
  window.reloadLazyVideos = scan;

  scan();

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node);
      });
    });
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll(selector).forEach((video) => {
      if (document.hidden) {
        if (video.autoplay && !video.paused) video.pause();
        return;
      }
      const rect = video.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        hydrate(video);
        playAutoplayVideo(video);
      }
    });
  });
})();
